import { render } from "./PreviewDetails.vue?vue&type=template&id=512533b2"
import script from "./PreviewDetails.vue?vue&type=script&lang=js"
export * from "./PreviewDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__